
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _0_46selection_46modalUOf1m7ctiGAfNZjT82Zsb0QgHGRMBTCzNKuOAJauySwMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/transferBoardRole/existingMember/0.selection.modal.vue?macro=true";
import { default as _1_46selectionOverview_46modalMke06v1kzY_WbgjpwCgIaGuvYX_kch_rQQqNN5LpekIMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/transferBoardRole/existingMember/1.selectionOverview.modal.vue?macro=true";
import { default as _2_46ownPosition_46modalUZtPR620ZgUsNXbKNNWhwJXOhHgQ_dYDr_GGM5C_w40Meta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/transferBoardRole/existingMember/2.ownPosition.modal.vue?macro=true";
import { default as _3_46documents_46modalGMN4_WcI4fx9xkIhGjGVpgReD1Xa7KxxsbUpsSzn_MwMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/transferBoardRole/existingMember/3.documents.modal.vue?macro=true";
import { default as _4_46overview_46modalwJ5wDqOG766ioXO4DFrVu_1jDki9R80uUecAwMW_u3kMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/transferBoardRole/existingMember/4.overview.modal.vue?macro=true";
import { default as _5_46success_46modalWfqJDKqFhRqdFPgCISip_Dy1qvMM_YR3Zxge7b8_7DYMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/transferBoardRole/existingMember/5.success.modal.vue?macro=true";
import { default as selectionOverview_46modalWflwQsqyOYLf5WLcBLFFet8HcIKF3kJg7NXMQuVr3dAMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/delete/selectionOverview.modal.vue?macro=true";
import { default as success_46modalRci81jJJSnHO7eCfktXGgAV7KfJMs_QoZTky3Rlrm0sMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/delete/success.modal.vue?macro=true";
import { default as select_46modalcCOF5BQPbnKyQ0cUsCH5aiHGfZgHsUn0vYeWxL12jBwMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/invite/select.modal.vue?macro=true";
import { default as selectionOverview_46modalZP9lMgXfrLYbf2bWjEzAodpk_ZucxMgNxr6Pne1XipcMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/invite/selectionOverview.modal.vue?macro=true";
import { default as success_46modalQFKN34dJScPDTt3ksympA4gGjRGb5lhw1MOiU2jvOWsMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/invite/success.modal.vue?macro=true";
import { default as _0_46confirm_46modallMiVZT_tD4pboNcgwyBbOfWeNtL32cqdiOYwXlKLFioMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/resign/0.confirm.modal.vue?macro=true";
import { default as _1_46success_46modalcuvON_aBTqVe_9ykdDiclQuKRTq9SJy9Wyy613kHxPsMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/resign/1.success.modal.vue?macro=true";
import { default as _0_46selection_46modal_yE_I1KYJHMPRFOUtX1MAV2_cCbhCLE3SanqSXVMD_gMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/revokeBoardRole/0.selection.modal.vue?macro=true";
import { default as _1_46confirm_46modalJk2JEq49H4_m731Axb8Ymr6N5ur0UDipj1qL6KMJ5bgMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/revokeBoardRole/1.confirm.modal.vue?macro=true";
import { default as _2_46success_46modalvtWg5ZzErlIoaNrStsOLsqgV_OwAT0cinqvqhl8i2_UMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/revokeBoardRole/2.success.modal.vue?macro=true";
import { default as success_46modalJmDXjtYlDoT61qeO3v9_V8ppsA01C2Uda4tcz8YYoFAMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/upload/success.modal.vue?macro=true";
import { default as upload_46modalCO2ztBpdKNlQ6D2dpbz1T26FB1CiRM3HxfT7w5Y2sywMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/upload/upload.modal.vue?macro=true";
import { default as createMember_46modal1BFdh3LeQnSUEOPtq9FKRp5BDw0Sp1QT3atIJv2C_p8Meta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/createMember.modal.vue?macro=true";
import { default as editMember_46modala6toDn_GH4pChOksfUKKNt_PjMiE4c92c5w3dW1XgIYMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/editMember.modal.vue?macro=true";
import { default as memberList_46modalLq02QGfH5pkdId_XjCnGRyKbabv_D2z0n3qXzRp7faMMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/memberList.modal.vue?macro=true";
import { default as accountxs2_T86_8oixqP7AtJZEclgfq8baGZLDvDg6PdON16AMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/home/account.vue?macro=true";
import { default as dashboard_OWESpSHZlt4YumViEjRdDSibjk3RpVVJon2KWEX9FcMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/home/dashboard.vue?macro=true";
import { default as membersnmAqnkPJilrt_US9zMTtdM6uJt9GFuXYXfStsbdKJw4Meta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/home/members.vue?macro=true";
import { default as homesx4Vg4d22sbv87DaNXrYCs3LJK9tQyicuViHDCGebcMMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/home.vue?macro=true";
import { default as createU8HJjTnmnZtSqt4QPDRLbFimOHkrumC1pOK2Y_QYgUIMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/onboarding/associationBoardMembership/create.vue?macro=true";
import { default as updateQ75sCw3TbOqeArFVmOoWekZsK1v7VM8Lx0ZH6lzCP8AMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/onboarding/associationBoardMembership/update.vue?macro=true";
import { default as abortedA8LlhuHGC8PS3_w3t2RrRpnZ3gTstAvCne249kcbIwsMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/onboarding/legitimation/aborted.vue?macro=true";
import { default as fraud7qVd6vQtfbRKNZGGWGZWKPmR0n5SU_fBT3QKWjF6790Meta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/onboarding/legitimation/fraud.vue?macro=true";
import { default as pendingVcbu1h5u6qjiurMNMEUfJPP0IvjOhfen8NbRWbLmMn0Meta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/onboarding/legitimation/pending.vue?macro=true";
import { default as associationRegistrationr5y5mJNWkmm3NNVckMbDg_I9i2tt4SAggp9LhyXY584Meta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/onboarding/associationRegistration.vue?macro=true";
import { default as associationSelectionqJqJiqKL_gA_qDZLsjdrYzrT5qxnoWnzRhfY8_DMI6cMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/onboarding/associationSelection.vue?macro=true";
import { default as introductionxU5nQVMAzSNpUCBGArEP_OPcbckdMpjkt7CKlDNpFZsMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/onboarding/introduction.vue?macro=true";
import { default as indexXmO6PU1HDSLp0AoTEgyD9IqKLBdBRnQpkKMtVC4bMHQMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/onboarding/legitimation/index.vue?macro=true";
import { default as loginOrRegisterpr3r_yN8NpkV_dlumVkCEyD1CjovHpHxE1bUcw8vRSkMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/onboarding/loginOrRegister.vue?macro=true";
import { default as onboarding8_Rxc_LkSh8Ecn7tzZjnoXy4aTYs51kWG2e77qMRCJgMeta } from "/opt/atlassian/pipelines/agent/build/clients/main/app/pages/onboarding.vue?macro=true";
export default [
  {
    name: "modals-transferBoardRole-existingMember-0.selection.modal",
    path: "/modals/transferBoardRole/existingMember/0.selection.modal",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/transferBoardRole/existingMember/0.selection.modal.vue")
  },
  {
    name: "modals-transferBoardRole-existingMember-1.selectionOverview.modal",
    path: "/modals/transferBoardRole/existingMember/1.selectionOverview.modal",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/transferBoardRole/existingMember/1.selectionOverview.modal.vue")
  },
  {
    name: "modals-transferBoardRole-existingMember-2.ownPosition.modal",
    path: "/modals/transferBoardRole/existingMember/2.ownPosition.modal",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/transferBoardRole/existingMember/2.ownPosition.modal.vue")
  },
  {
    name: "modals-transferBoardRole-existingMember-3.documents.modal",
    path: "/modals/transferBoardRole/existingMember/3.documents.modal",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/transferBoardRole/existingMember/3.documents.modal.vue")
  },
  {
    name: "modals-transferBoardRole-existingMember-4.overview.modal",
    path: "/modals/transferBoardRole/existingMember/4.overview.modal",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/transferBoardRole/existingMember/4.overview.modal.vue")
  },
  {
    name: "modals-transferBoardRole-existingMember-5.success.modal",
    path: "/modals/transferBoardRole/existingMember/5.success.modal",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/transferBoardRole/existingMember/5.success.modal.vue")
  },
  {
    name: "modals-delete-selectionOverview.modal",
    path: "/modals/delete/selectionOverview.modal",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/delete/selectionOverview.modal.vue")
  },
  {
    name: "modals-delete-success.modal",
    path: "/modals/delete/success.modal",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/delete/success.modal.vue")
  },
  {
    name: "modals-invite-select.modal",
    path: "/modals/invite/select.modal",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/invite/select.modal.vue")
  },
  {
    name: "modals-invite-selectionOverview.modal",
    path: "/modals/invite/selectionOverview.modal",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/invite/selectionOverview.modal.vue")
  },
  {
    name: "modals-invite-success.modal",
    path: "/modals/invite/success.modal",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/invite/success.modal.vue")
  },
  {
    name: "modals-resign-0.confirm.modal",
    path: "/modals/resign/0.confirm.modal",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/resign/0.confirm.modal.vue")
  },
  {
    name: "modals-resign-1.success.modal",
    path: "/modals/resign/1.success.modal",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/resign/1.success.modal.vue")
  },
  {
    name: "modals-revokeBoardRole-0.selection.modal",
    path: "/modals/revokeBoardRole/0.selection.modal",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/revokeBoardRole/0.selection.modal.vue")
  },
  {
    name: "modals-revokeBoardRole-1.confirm.modal",
    path: "/modals/revokeBoardRole/1.confirm.modal",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/revokeBoardRole/1.confirm.modal.vue")
  },
  {
    name: "modals-revokeBoardRole-2.success.modal",
    path: "/modals/revokeBoardRole/2.success.modal",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/revokeBoardRole/2.success.modal.vue")
  },
  {
    name: "modals-upload-success.modal",
    path: "/modals/upload/success.modal",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/upload/success.modal.vue")
  },
  {
    name: "modals-upload-upload.modal",
    path: "/modals/upload/upload.modal",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/upload/upload.modal.vue")
  },
  {
    name: "modals-createMember.modal",
    path: "/modals/createMember.modal",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/createMember.modal.vue")
  },
  {
    name: "modals-editMember.modal",
    path: "/modals/editMember.modal",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/editMember.modal.vue")
  },
  {
    name: "modals-memberList.modal",
    path: "/modals/memberList.modal",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/modals/memberList.modal.vue")
  },
  {
    name: "home",
    path: "/home",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/home.vue"),
    children: [
  {
    name: "home-account",
    path: "account",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/home/account.vue")
  },
  {
    name: "home-dashboard",
    path: "dashboard",
    alias: ["/"],
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/home/dashboard.vue")
  },
  {
    name: "home-members",
    path: "members",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/home/members.vue")
  }
]
  },
  {
    name: "onboarding",
    path: "/onboarding",
    meta: onboarding8_Rxc_LkSh8Ecn7tzZjnoXy4aTYs51kWG2e77qMRCJgMeta || {},
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/onboarding.vue"),
    children: [
  {
    name: "onboarding-associationBoardMembership-create",
    path: "associationBoardMembership/create",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/onboarding/associationBoardMembership/create.vue")
  },
  {
    name: "onboarding-associationBoardMembership-update",
    path: "associationBoardMembership/update",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/onboarding/associationBoardMembership/update.vue")
  },
  {
    name: "onboarding-legitimation-aborted",
    path: "legitimation/aborted",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/onboarding/legitimation/aborted.vue")
  },
  {
    name: "onboarding-legitimation-fraud",
    path: "legitimation/fraud",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/onboarding/legitimation/fraud.vue")
  },
  {
    name: "onboarding-legitimation-pending",
    path: "legitimation/pending",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/onboarding/legitimation/pending.vue")
  },
  {
    name: "onboarding-associationRegistration",
    path: "associationRegistration",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/onboarding/associationRegistration.vue")
  },
  {
    name: "onboarding-associationSelection",
    path: "associationSelection",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/onboarding/associationSelection.vue")
  },
  {
    name: "onboarding-introduction",
    path: "introduction",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/onboarding/introduction.vue")
  },
  {
    name: "onboarding-legitimation",
    path: "legitimation",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/onboarding/legitimation/index.vue")
  },
  {
    name: "onboarding-loginOrRegister",
    path: "loginOrRegister",
    component: () => import("/opt/atlassian/pipelines/agent/build/clients/main/app/pages/onboarding/loginOrRegister.vue")
  }
]
  }
]